import { Logo } from './Logo';

const Header = () => {
  return (
    <header className='flex justify-start px-8 py-6'>
      <Logo className='h-7' />
    </header>
  );
};

export default Header;
